import { render, staticRenderFns } from "./OfertaStatus.vue?vue&type=template&id=52a5b23e"
import script from "./OfertaStatus.vue?vue&type=script&lang=js"
export * from "./OfertaStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports